import { Flex, Skeleton } from 'antd'
import { BudgetCoinLoader } from 'src/pages/budget/components/budgetCoinLoader'

export const FormSkeleton = () => {
  const { Input } = Skeleton
  return (
    <Flex vertical gap={16}>
      <BudgetCoinLoader />
      <Skeleton active paragraph={{ rows: 3, width: '100%' }} title={false} />
      <Input block active style={{ height: 700 }} />
    </Flex>
  )
}
